import {defineStore} from 'pinia';
import apiRequest from '@/util/api-request';
import { AxiosRequestConfig } from 'axios';

interface IExerciseSpeech{
    is_expand: boolean;
}

export const useExerciseSpeechStore = defineStore('exerciseSpeechStore', {
    // state
    state: (): IExerciseSpeech => {
        return {
            // save text-to-speech modal speed and seekbar hide/expansion session
            is_expand: true
        }
    },
  // actions
    actions: {
        async fetchTextToSpeech(subjectField:string, htmlText: string) {
            const config: AxiosRequestConfig = {
                 method: 'post',
                url: '/exercise/api/speech/text_to_speech',
                data: {
                    "subject_field": subjectField,
                    "html": htmlText,
                },
                responseType: 'blob'
            };
            return await apiRequest(config);
        },
    }
})